//use this store to track the open sheets

import { create } from "zustand";

interface StackedSheetStore {
  sheetCount: number;
  addSheet: () => number;
  removeSheet: () => void;
}
export const useStackedSheetStore = create<StackedSheetStore>()((set, get) => ({
  sheetCount: 0,
  addSheet: () => {
    const { sheetCount } = get();
    const newCount = sheetCount + 1;
    set({ sheetCount: newCount });
    return newCount;
  },
  removeSheet: () => {
    set((state) => ({ sheetCount: state.sheetCount - 1 }));
  },
}));
